<template>
  <a-modal
    width="1000px"
    :visible="modalVisible"
    @cancel="modalCancel"
    @ok="modalSubmit"
    cancelText="取消"
    okText="确认"
    :title="
      !modalType
        ? '创建活动规则'
        : modalType === 1
        ? '编辑活动规则'
        : '活动规则详情'
    "
  >
    <a-radio-group v-model:value="langCode" class="ml80 mb20">
      <a-radio-button
        v-for="lang in langDic"
        :key="lang.value"
        :value="lang.value"
        >{{ lang.label }}</a-radio-button
      >
    </a-radio-group>
    <a-form
      ref="activityRef"
      :model="activityParams"
      :labelCol="{ span: 4 }"
      :rules="activityRules"
    >
      <a-form-item label="规则名称" name="activityName">
        <a-input
          v-model:value="activityParams.activityName"
          :disabled="isEditDisabled"
          :bordered="modalType !== 2"
          style="width: 120px"
          :maxlength="50"
        />
      </a-form-item>
      <a-form-item label="活动时间" name="timeSet">
        <p v-if="modalType === 2">
          {{ activityParams.startTime }} ~ {{ activityParams.endTime }}
        </p>
        <a-range-picker
          v-model:value="activityParams.timeSet"
          show-time
          :disabled="isEditDisabled"
          :format="'YYYY-MM-DD HH:mm:ss'"
          :placeholder="['开始时间', '结束时间']"
          @change="timeChange"
          v-else
        />
      </a-form-item>
      <a-form-item label="活动条件设置">
        <table style="border-collapse: collapse;">
          <td v-for="item in conditionsList" :key="item.label" class="item">
            <p class="label">{{ item.label }}</p>
            <p class="value " v-if="item.label === '条件值'">
              <a-form-item
                name="orderCount"
                :rules="[
                  {
                    required: true,
                    trigger: 'change',
                    validator: formRules
                  }
                ]"
              >
                <p v-if="modalType">{{ activityParams.orderCount }}</p>
                <a-input
                  v-else
                  class="w80"
                  type="Number"
                  :disabled="isEditDisabled"
                  v-model:value="activityParams.orderCount"
                />
              </a-form-item>
            </p>
            <p class="value" v-else-if="item.label === '关联券规则'">
              <a-form-item
                name="discountRuleId"
                :rules="[
                  {
                    required: true,
                    trigger: 'change',
                    validator: formRules
                  }
                ]"
              >
                <p v-if="modalType === 2">
                  {{ activityParams.discountRuleId }}
                </p>
                <a-input
                  v-else
                  class="w80"
                  type="Number"
                  :disabled="isEditDisabled"
                  v-model:value="activityParams.discountRuleId"
                />
              </a-form-item>
            </p>
            <p class="value" v-else-if="item.label === '券有效日期'">
              <a-form-item
                name="validDays"
                :rules="[
                  {
                    required: true,
                    trigger: 'change',
                    validator: formRules
                  }
                ]"
              >
                <p v-if="modalType === 2">{{ activityParams.validDays }}天</p>
                <p v-else>
                  <a-input
                    class="w60"
                    :disabled="isEditDisabled"
                    type="Number"
                    v-model:value="activityParams.validDays"
                  />天
                </p>
              </a-form-item>
            </p>
            <p v-else class="value" style="padding: 15px 0;">
              {{ item.value }}
            </p>
          </td>
        </table>
      </a-form-item>
      <div
        v-for="(item, index) in activityParams.langs"
        :key="index"
        v-show="item.langCode === langCode"
      >
        <a-form-item label="主标题" required>
          <a-input
            v-model:value="item.mainTitle"
            required
            style="width: 120px"
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            :maxlength="50"
          />
        </a-form-item>
        <a-form-item label="副标题" required>
          <a-input
            v-model:value="item.subTitle"
            required
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            style="width: 120px"
            :maxlength="50"
          />
        </a-form-item>
        <a-form-item label="入口按钮名称" required>
          <a-input
            v-model:value="item.buttonName"
            :disabled="modalType === 2"
            :bordered="modalType !== 2"
            style="width: 120px"
            :maxlength="50"
          />
        </a-form-item>
      </div>
      <a-form-item label="图片" name="icon">
        <UpdateImage
          v-if="modalVisible"
          :disabled="isEditDisabled"
          :imageType="imageType"
          :defaultUrl="activityParams.icon"
          @setImgUrl="setImgUrl"
          @delActivityImg="delActivityImg"
        ></UpdateImage>
      </a-form-item>
      <a-form-item label="状态" required>
        <a-radio-group
          v-model:value="activityParams.status"
          v-if="modalType !== 2"
          :disabled="isEditDisabled"
        >
          <a-radio :value="1">启用</a-radio>
          <a-radio :value="2">停用</a-radio>
        </a-radio-group>
        <p v-else>{{ activityParams.status === 1 ? '启用' : '停用' }}</p>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import UpdateImage from './UploadImg.vue'
import { inject, toRefs } from 'vue'
export default {
  components: {
    UpdateImage
  },
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>

<style lang="scss" scoped>
.ant-input[disabled] {
  color: #000;
}
.item {
  text-align: center;
  border: 1px solid #dedede;
  .label {
    padding: 10px 15px;
    white-space: nowrap;
  }
  .value {
    height: 100%;
    white-space: nowrap;
    padding: 10px 15px;
    border-top: 1px solid #dedede;
    .ant-form-item {
      margin: 0;
    }
  }
}
</style>
